// Dependencies
import { FC, ReactElement } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// Components
import { LocalizationProvider } from "@mui/x-date-pickers";

interface LocalizationWrapperProps {
  children: ReactElement;
}

const LocalizationWrapper: FC<LocalizationWrapperProps> = ({ children }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {children}
    </LocalizationProvider>
  );
};

export default LocalizationWrapper;
